import { inject, Injectable } from '@angular/core';
import { EeaOutputProjectPwcApiService } from './eea-output-project-pwc.api.service';
import { lastValueFrom, take } from 'rxjs';
import { InputsResultSummaryPWC, ResultSummaryPWC } from './eea-output-project-pwc.interface.model';

@Injectable({
  providedIn: 'root'
})
export class EeaOutputProjectPwcLogicService {

  private apiService = inject(EeaOutputProjectPwcApiService);

  public async getSummaryResultPwc( projectPk: number ): Promise<ResultSummaryPWC[]> {
    const source$ = this.apiService.getSummaryResultPwc(projectPk).pipe(take(1));
    return await lastValueFrom(source$);
  }

  public async getResultSummaryPwcInputs( projectPk: number ): Promise<InputsResultSummaryPWC[]> {
    const source$ = this.apiService.getResultSummaryPwcInputs(projectPk).pipe(take(1));
    return await lastValueFrom(source$);
  }

}
